/* TODO: when c2CustomComponents is removed, we can simplify this to just the background and margin properties.
We can also remove the -webkit-scrollbar style as this is applied directly in CategoryTabs */
.categorySelector {
  display: flex;
  overflow: auto;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  justify-content: flex-start;
  scrollbar-width: none; /* Firefox */
  background: var(--colors-background);
  margin-left: var(--page-margin);
  margin-right: var(--page-margin);
}

.categorySelector::-webkit-scrollbar {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .categorySelector {
    margin-left: var(--page-margin-desktop);
    margin-right: var(--page-margin-desktop);
  }
}
